__webpack_require__.p = "/U-Life/";